export const AvoidEnum = Object.freeze({
    highWay: "motorway",
    ferryRoute: "ferry",
    tunnel: "tunnel",
    toll: "toll"
})